import { useMemo } from 'react';
import type { OutpatientClinicTask } from '@common/contexts/support/domain/models/outpatientClinicTaskModel';

type GroupedCategory = {
    id: string;
    name: string;
};

export function useGroupedCategories(types: OutpatientClinicTask['type'][]) {
    return useMemo(() => {
        const categoriesMap: Record<string, GroupedCategory> = {};

        types.forEach((type) => {
            const categoryName = type.category.name;
            if (!categoriesMap[categoryName]) {
                categoriesMap[categoryName] = {
                    id: type.category.id,
                    name: type.category.name,
                };
            }
        });

        return Object.values(categoriesMap);
    }, [types]);
}
